export default __webpack_public_path__ + "images/icons/ic_play_circle.svg";